
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[referralCode]",
      function () {
        return require("private-next-pages/p/[referralCode]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[referralCode]"])
      });
    }
  